import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

import CountryLogo from './images/country-logo.svg';

export const Currency = styled.span`
  z-index: 1;
  margin-left: 8px;
`;

export const Divider = styled.div`
  width: 0.5px;
  height: 16px;
  margin-left: 8px;
  background-color: ${uiToken.color.border.default};
  z-index: 1;
`;

export const StyledCountryLogo = styled(CountryLogo)`
  z-index: 1;
  width: 16px;
`;
